import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import FoodSearchBox from '../../components/health/FoodSearchBox';
import TopicChip from '../../components/health/TopicChip';
import foodTopics from '../../data/health/foodTopics';

const HealthFood = () => {
  return (
    <>
      <Helmet>
        <title>Food & Nutrients | Health</title>
        <meta name="description" content="Searchable knowledge base of nutrients, foods, and health topics — find what you need to know about protein, vitamins, minerals, and more." />
        <meta property="og:title" content="Food & Nutrient Knowledge Base" />
        <meta property="og:description" content="A searchable index of 30+ nutrition and health topics with citations." />
      </Helmet>

      <div className="health-page">
        <h1 className="health-page-title">Food & Nutrients</h1>
        <p className="text-gray-300" style={{ maxWidth: 640, marginBottom: '2rem' }}>
          Search or browse the knowledge base below. Each topic covers what it is, why it matters,
          good food sources, how much you need, and common myths — with citations.
        </p>

        <div className="health-search-sticky">
          <FoodSearchBox />
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          <h2 style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '1rem', fontFamily: '"DM Sans", sans-serif' }}>
            All Topics
          </h2>
          <div className="health-chips-grid">
            {foodTopics.map((topic) => (
              <TopicChip key={topic.slug} topic={topic} />
            ))}
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default HealthFood;
